module.exports = __webpack_public_path__ + "img/inbound.bc86e089.svg";